var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilienrecht(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146.03 145.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00355b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.38,144.29c-.09-4.76-1.88-10.29-5.3-14.9-4.87-6.57-11.98-10.11-20.12-10.58-4.66-.27-10.11-.32-14.8-.13-8.34.34-15.95,4.06-20.91,10.78-3.39,4.59-5.24,15.83-5.24,15.83H13.09c-7.12-.44-12.46-5.77-12.88-12.89.49-15.78-.65-31.95,0-47.68.72-17.55,14.08-31.45,31.68-32.43h82.9c17.16.86,30.84,15.06,31.22,32.2-.1,16.13.18,32.27-.14,48.39-1.01,6.52-6.15,11.04-12.73,11.41h-26.77ZM71.3,73.01c-13.37,1.04-21.66,15.49-16.36,27.72,6.48,14.96,27.54,16.14,35.55,1.9,7.96-14.16-3.15-30.88-19.19-29.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.26.05c18.28-1.16,30.68,18.46,21.72,34.52-8.66,15.52-31.09,15.78-40.19.53C7.9,20.19,18.05,1.15,35.26.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.09.05c18.57-1.22,31.08,18.99,21.5,35.05-9.1,15.26-31.53,14.99-40.19-.53C81.1,19.68,91.17,1.17,108.09.05Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilienrecht);
export default __webpack_public_path__ + "static/media/Familienrecht.aeb2be5c120e88453b8c1b8fa87da53a.svg";
export { ForwardRef as ReactComponent };